// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__lWshW","loadingText":"Loader_loadingText__HNHd2"};